/*
  SCK - Show sold-out variants on product pages (Oct 2026)

  Loaded after theme.js (both deferred, so this runs before theme.js
  initialises product sections on DOMContentLoaded).

  1. Selecting an option keeps the exact variant the shopper picked, even
     when it is sold out, so the buy button can say "Sold Out".
     The closest-available fallback is only used when the picked
     combination does not exist at all.
  2. Option values that belong to a real but sold-out variant are shown,
     selectable and marked "Sold Out". Values with no matching variant
     (non-existent combinations) keep the theme's "disabled" state.
  3. The dynamic checkout (Buy it now / Shop Pay) button is hidden while a
     sold-out variant is selected; the add-to-cart button is disabled by
     theme.js (updateCartButton) and reads theme.strings.soldOut.
*/
(function () {
  'use strict';

  if (!window.theme || !theme.Variants || !theme.VariantAvailability) return;
  if (theme.sckVariantAvailability) return;
  theme.sckVariantAvailability = true;

  var SOLD_OUT_CLASS = 'sck-sold-out';
  var TAG_CLASS = 'sck-sold-out-tag';
  var soldOutText = (theme.strings && theme.strings.soldOut) || 'Sold Out';

  /* ---------- 1. Keep the selected variant, even when sold out ---------- */
  theme.Variants.prototype._getVariantFromOptions = function (lastSelectedOption) {
    var fullMatch = this._getFullMatch(false);
    if (fullMatch) return fullMatch;
    if (!this.dynamicVariantsEnabled) return null;
    return this._getClosestAvailableMatch(lastSelectedOption) || null;
  };

  /* ---------- 2. Mark sold-out option values ---------- */
  function getVariants(container) {
    if (container._sckVariants) return container._sckVariants;
    var json = container.querySelector('[data-variant-json]');
    if (!json) return null;
    try {
      container._sckVariants = JSON.parse(json.textContent || json.innerHTML);
    } catch (e) {
      return null;
    }
    return container._sckVariants;
  }

  function getSelectedValues(container) {
    var selected = {};
    container.querySelectorAll('.variant-input-wrap').forEach(function (group) {
      var index = group.dataset.index;
      var select = group.querySelector('select');
      if (select) {
        selected[index] = select.value;
      } else {
        var checked = group.querySelector('input:checked');
        if (checked) selected[index] = checked.value;
      }
    });
    return selected;
  }

  // 'available' | 'soldout' | 'none', matching the theme's own rules:
  // option1 looks at every variant, option2 at variants sharing the
  // selected option1, option3 at variants sharing option1 and option2.
  function valueState(variants, index, value, selected) {
    var position = parseInt(index.replace('option', ''), 10);
    var exists = false;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v[index] !== value) continue;
      var parentsMatch = true;
      for (var p = 1; p < position; p++) {
        var key = 'option' + p;
        if (selected[key] !== undefined && v[key] !== selected[key]) {
          parentsMatch = false;
          break;
        }
      }
      if (!parentsMatch) continue;
      if (v.available) return 'available';
      exists = true;
    }
    return exists ? 'soldout' : 'none';
  }

  function markButton(wrapper, state) {
    var input = wrapper.querySelector('input');
    var label = wrapper.querySelector('label');
    if (!input || !label) return;
    var tag = label.querySelector('.' + TAG_CLASS);

    if (state === 'soldout') {
      input.classList.remove('disabled');
      label.classList.remove('disabled');
      input.classList.add(SOLD_OUT_CLASS);
      label.classList.add(SOLD_OUT_CLASS);
      if (!tag) {
        tag = document.createElement('span');
        tag.className = TAG_CLASS;
        tag.textContent = soldOutText;
        label.appendChild(tag);
      }
    } else {
      input.classList.remove(SOLD_OUT_CLASS);
      label.classList.remove(SOLD_OUT_CLASS);
      if (tag) tag.remove();
      if (state === 'available') {
        input.classList.remove('disabled');
        label.classList.remove('disabled');
      }
      // state 'none' keeps whatever 'disabled' state the theme set
    }
  }

  function markOption(option, state) {
    if (!option.dataset.sckLabel) option.dataset.sckLabel = option.textContent.trim();
    var base = option.dataset.sckLabel;
    if (state === 'soldout') {
      option.disabled = false;
      option.classList.add(SOLD_OUT_CLASS);
      option.textContent = base + ' - ' + soldOutText;
    } else {
      option.classList.remove(SOLD_OUT_CLASS);
      option.textContent = base;
      if (state === 'available') option.disabled = false;
      // state 'none' keeps the theme's disabled flag
    }
  }

  function markContainer(container) {
    if (!container) return;
    var variants = getVariants(container);
    if (!variants || !variants.length) return;
    var selected = getSelectedValues(container);
    var soldOutSelected = false;

    container.querySelectorAll('.variant-input-wrap').forEach(function (group) {
      var index = group.dataset.index;
      if (!index) return;
      var select = group.querySelector('select');
      if (select) {
        select.querySelectorAll('option').forEach(function (option) {
          markOption(option, valueState(variants, index, option.value, selected));
        });
      } else {
        group.querySelectorAll('.variant-input').forEach(function (wrapper) {
          markButton(wrapper, valueState(variants, index, wrapper.dataset.value, selected));
        });
      }
    });

    // Is the exact selected combination a sold-out variant?
    var keys = Object.keys(selected);
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = keys.every(function (k) { return v[k] === selected[k]; });
      if (match) {
        soldOutSelected = !v.available;
        break;
      }
    }
    container.querySelectorAll('.product-single__form').forEach(function (form) {
      form.classList.toggle('sck-variant-sold-out', soldOutSelected);
    });
  }

  function containerFor(el) {
    return el && el.closest('[data-section-type="product"], [data-section-type="featured-product"], .product-section');
  }

  // Re-mark right after the theme updates availability.
  var VAP = theme.VariantAvailability.prototype;
  ['setInitialAvailability', 'setAvailability'].forEach(function (method) {
    var original = VAP[method];
    if (typeof original !== 'function') return;
    VAP[method] = function () {
      var result = original.apply(this, arguments);
      markContainer(containerFor(this.container) || this.container);
      return result;
    };
  });

  // Also cover pickers where dynamic variants are switched off (the theme
  // does not run VariantAvailability there) and quick-view modals.
  document.addEventListener('change', function (evt) {
    var target = evt.target;
    if (!target || !target.matches || !target.matches('[data-variant-input]')) return;
    var container = containerFor(target);
    setTimeout(function () { markContainer(container); }, 0);
  });

  function markAll() {
    document.querySelectorAll('[data-variant-json]').forEach(function (json) {
      markContainer(containerFor(json));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(markAll, 0); });
  } else {
    markAll();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(markAll, 0); });
  document.addEventListener('quickshop:opened', function () { setTimeout(markAll, 0); });
})();
